module.exports = __webpack_public_path__ + "static/media/scca-runoffs.907fe33d.png";


//////////////////
// WEBPACK FOOTER
// ./html/assets/images/scca-runoffs.png
// module id = 1163
// module chunks = 0